import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    padding: 0,
    '&.MuiStepLabel-vertical': {
      alignItems: 'unset',
      '& .MuiStepLabel-labelContainer': {
        paddingTop: `calc(${idsTokens.stepper.default.spacing.vertical.text.top} + 2px)`,
      },
      '& .Mui-active:not(.Mui-completed)': {
        paddingLeft: 1,
      },
    },
  },
  label: {
    color: idsTokens.stepper.default.color.incomplete.text.enabled,
    fontWeight: idsTokens.typography.font.weight.bold,
    fontSize: idsTokens.typography.font.size.base,
    lineHeight: idsTokens.typography.lineHeight.base,
    letterSpacing: idsTokens.typography.spacing.letter.lg,
    '&.Mui-active, &.Mui-completed': {
      color: idsTokens.stepper.default.color.completed.text.enabled,
      fontWeight: idsTokens.typography.font.weight.bold,
    },
    '&.MuiStepLabel-alternativeLabel': {
      marginTop: 0,
      marginRight: 6,
    },
  },
  vertical: {
    '& .MuiStepLabel-label.Mui-active:not(.Mui-completed)': {
      marginLeft: -2,
    },
  },
});
